import {
  GET_UNSUBS_DATA,
  GET_UNSUBS_DATA_SUCCESS,
  GET_UNSUBS_DATA_FAIL,
  GET_UNSUBS_DATA_TOTAL,
  GET_UNSUBS_DATA_TOTAL_SUCCESS,
  GET_UNSUBS_DATA_TOTAL_FAIL,
  GET_UNSUBS_DRILL_DATA,
  GET_UNSUBS_DRILL_DATA_SUCCESS,
  GET_UNSUBS_DRILL_DATA_FAIL
} from '../constants/unsubs';

const initialState = {
  loading: false,
  loaded: false,
  data: null,
  error: null,
  drillLoaded: false,
  drillLoading: false,
  drillData: null,
  totalData: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_UNSUBS_DATA:
      return {
        ...state,
        [action.graphId]: {
          ...state[action.graphId],
          loading: true,
          loaded: false,
          data: null,
          error: null
        }
      };
    case GET_UNSUBS_DATA_FAIL:
      return {
        ...state,
        [action.graphId]: {
          ...state[action.graphId],
          loading: false,
          loaded: false,
          data: null,
          error: action.error
        }
      };
    case GET_UNSUBS_DATA_SUCCESS:
      return {
        ...state,
        [action.graphId]: {
          ...state[action.graphId],
          loading: false,
          loaded: true,
          data: action.data,
          error: null
        }
      };
    case GET_UNSUBS_DATA_TOTAL:
      return {
        ...state,
        [action.graphId]: {
          ...state[action.graphId],
          totalLoading: true,
          totalLoaded: false,
          totalData: null,
          error: null
        }
      };
    case GET_UNSUBS_DATA_TOTAL_FAIL:
      return {
        ...state,
        [action.graphId]: {
          ...state[action.graphId],
          totalLoading: false,
          totalLoaded: false,
          totalData: null,
          error: action.error
        }
      };
    case GET_UNSUBS_DATA_TOTAL_SUCCESS:
      return {
        ...state,
        [action.graphId]: {
          ...state[action.graphId],
          totalLoading: false,
          totalLoaded: true,
          totalData: action.data,
          error: null
        }
      };
    case GET_UNSUBS_DRILL_DATA:
      return {
        ...state,
        drillLoading: true,
        drillLoaded: false,
        drillData: null,
        error: null
      };
    case GET_UNSUBS_DRILL_DATA_SUCCESS:
      return {
        ...state,
        drillLoading: false,
        drillLoaded: true,
        drillData: action.data,
        error: null
      };
    case GET_UNSUBS_DRILL_DATA_FAIL:
      return {
        ...state,
        drillLoading: false,
        drillLoaded: false,
        drillData: null,
        error: action.error
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/unsubs.js